const PREFIX = 'joykit';

const prefixClassName = (name: string): string => `${PREFIX}-${name}`;

export const BUTTON_SPINNER = prefixClassName('button-spinner');
export const CHOICE_INDICATOR = prefixClassName('choice-indicator');
